var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.34 16.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a4a4a;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.02,7.97c-1.44-2.1-4.5-6.59-10.15-6.75-.88-.03-1.98.16-2.75.33l.91,1.31c.51-.08,1.24-.15,1.8-.14,4.51.13,7.14,3.48,8.67,5.68-.8,1.03-2.09,2.42-3.82,3.44l.9,1.21c2.19-1.33,3.69-3.14,4.46-4.18l.31-.43-.32-.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.72,7.85l1.2,1.62c.18-.41.3-.85.32-1.33.06-2.07-1.57-3.8-3.64-3.86-.17,0-.33,0-.49.03l1.21,1.63c.78.31,1.34,1.04,1.41,1.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.69,0l1.97,2.66C3.02,4.13,1.31,6.47.33,7.82l-.33.46.3.44c1.29,1.87,4.72,6.15,10.37,6.15,1.31,0,2.49-.24,3.56-.62l1.56,2.11h1.87L5.55,0h-1.87ZM10.67,13.36c-4.49,0-7.42-3.16-8.83-5.07,1.03-1.4,2.55-3.26,4.72-4.4l1.3,1.76c-.59.66-.95,1.51-.95,2.46,0,2.07,1.68,3.75,3.75,3.75.55,0,1.07-.13,1.54-.34h0s1.07,1.45,1.07,1.45c-.8.24-1.67.39-2.62.39ZM11.28,10.27c-.2.06-.4.1-.61.1-1.24,0-2.25-1.01-2.25-2.25,0-.45.15-.86.38-1.21l2.49,3.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.0d56e85b4fb1911693dda4f3d10c3571.svg";
export { ForwardRef as ReactComponent };